<template>
    <MainContentSearchable title="Listado de plantillas" id="plantillas" v-model="filters" :meta="loading ? {} : plantillas.meta" @updated="debouncedGetPlantillas">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de plantillas</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.plantillas-whatsapp.crear' }" class="btn btn-primary" id="crear-plantilla">
                    Crear plantilla
                </router-link>
            </div>
        </template>

        <template v-slot:extra-options>
            <select class="custom-select w-auto mr-auto ml-3 mt-2" id="estado" v-model="filters.status" @change="debouncedGetPlantillas()">
                <option value="">Estados</option>
                <option v-for="estado in estados" :value="estado.id" :key="estado.id">
                    {{ estado.nombre }}
                </option>
            </select>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="[{ 'expanded': plantillas.data?.length <= 3, 'table-responsive': esMovil }]">
                    <div class="table">
                        <b-table hover :items="plantillas.data" :fields="fields">
                            <template #cell(language)="data">
                                <img :src="getFlag(data.item.language)" :alt="data.item.language" class="flag-icon"/>
                            </template>
                            <template #cell(opciones)="{ item, index }">
                                <OpcionesDropdownTableComponent
                                    :lastIndex="plantillas.data.length > 3 && index >= plantillas.data.length - 3"
                                    v-bind:options="[
                                        ...(item.status !== 'Eliminado' && item.status !== 'Pendiente de Eliminación'
                                            ? [{ to: { name: 'back.plantillas-whatsapp.editar', params: { plantilla_id: item.id } }, label: 'Editar' }]
                                            : []),
                                        { to: { name: 'back.plantillas-whatsapp.show', params: { plantilla_id: item.id } }, label: 'Detalle' },
                                        ...(item.status !== 'Eliminado' && item.status !== 'Pendiente de Eliminación'
                                            ? [{ type: 'action', action: () => showModal('sincronizar-' + item.id), label: 'Sincronizar' }]
                                            : []),
                                        ...(item.status !== 'Eliminado' && item.status !== 'Pendiente de Eliminación'
                                            ? [{ type: 'action', action: () => showModal('borrar-' + item.id), label: 'Borrar' }]
                                            : []),
                                    ]"
                                />                                
                                <ModalComponent
                                    :name="'sincronizar-' + item.id"
                                    title="Sincronizar con Facebook"
                                    @close="closeModal(false, 'sincronizar-' + item.id)"
                                >
                                    <h4>¿Estás seguro de que quieres sincronizar esta plantilla?</h4>
                                    <div class="d-flex justify-content-end">
                                        <Button variant="primary" @click="sincronizarPlantilla(item.id)">Confirmar</Button>
                                    </div>
                                </ModalComponent>
                                <BorrarModalComponent
                                    :name="'borrar-' + item.id"
                                    :title="'Borrar plantilla ' + item.name"
                                    confirmButton="¿Está segur@ de borrar esta plantilla?"
                                    @close="closeModal(false, 'borrar-' + item.id)"
                                    @confirm="borrarPlantilla(item.id)"
                                />
                            </template>
                            <template #cell(components)="{ item }">
                                <b-button id="show-btn" @click="$bvModal.show('modal-vista-previa-' + item.id)" variant="primary" size="sm">
                                    Mostrar/Ocultar
                                </b-button>
                                <b-modal centered :id="'modal-vista-previa-' + item.id" title="Vista previa" @hidden="$bvModal.hide('modal-vista-previa-' + item.id)">
                                    <VistaPreviaComponent :components="item.components" />
                                    <template #modal-footer>
                                        <b-button variant="secondary" @click="$bvModal.hide('modal-vista-previa-' + item.id)">Cerrar</b-button>
                                    </template>
                                </b-modal>
                            </template>
                        </b-table>
                    </div>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import VistaPreviaComponent from '@/components/backend/plantillas-whatsapp/VistaPreviaComponent';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                loading: false,
                plantillas: null,
                fields: [
                    { key: "name", label: "Nombre" },
                    { key: "status", label: "Estado", class: "text-center" },
                    { key: "language", label: "Idioma", class: "text-center" },
                    { key: "category", label: "Categoría", class: "text-center" },
                    { key: "components", label: "Vista previa", class: "text-center" },
                    { key: "opciones", label: "Opciones", class: "text-center" }
                ],
                estados: [
                    { id: 0, nombre: 'Pendiente' },
                    { id: 1, nombre: 'Aprobado' },
                    { id: 2, nombre: 'En Apelación' },
                    { id: 3, nombre: 'Rechazado' },
                    { id: 4, nombre: 'Pendiente de Eliminación' },
                    { id: 5, nombre: 'Eliminado' },
                    { id: 6, nombre: 'Deshabilitado' },
                    { id: 7, nombre: 'Pausado' },
                    { id: 8, nombre: 'Límite Excedido' },
                    { id: 9, nombre: 'Archivado' }
                ],
                filters: {
                    search: '',
                    per_page: 10,
                    page: 1,
                    name: '',
                    status: ''
                }
            }
        },
        created() {
            this.getPlantillas();
            this.debouncedGetPlantillas = _.debounce(this.getPlantillas, 500)
        },
        methods: {
            getPlantillas() {
                this.loading = true;

                this.filters.name = this.filters.search;
                this.filters.paginate = this.filters.per_page ?? 10;

                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.index'), params).then(res => {
                    this.plantillas = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            sincronizarPlantilla(plantilla_id) {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    plantilla_id: plantilla_id
                };
            
                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.sincronizar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getPlantillas();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrarPlantilla(plantilla_id) {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    plantilla_id: plantilla_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getPlantillas();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            getFlag(language) {
                const flags = {
                    'es_ES': 'https://flagcdn.com/w40/es.png',
                    'en_US': 'https://flagcdn.com/w40/us.png',
                    'en': 'https://flagcdn.com/w40/gb.png',
                    'ca': 'https://flagcdn.com/w40/cat.png'
                };

                return flags[language];
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(terminado, modal) {
                this.$modal.hide(modal);

                if(terminado) {
                    this.getPlantillas();
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        components: {
            MainContentSearchable, VistaPreviaComponent, OpcionesDropdownTableComponent, ModalComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}

.flag-icon {
    width: 24px;
    height: 16px;
}
</style>